/**
 * hls.js settings for the Speedy player (F-129). The shared tuning, with a 10-second buffer so the
 * next Speedy loads 10 s and stops (Tim, 16 Oct), a low first rung at full screen, and no
 * bandwidth test before the first segment. `hls-config.ts` itself is unchanged.
 */
import type { HlsConfig } from 'hls.js';
import { BASE_HLS_CONFIG } from '@/components/media/hls-config';
import { SpeedyLoader } from './speedy-hls-loader';

export const SPEEDY_HLS_CONFIG = {
  ...BASE_HLS_CONFIG,
  maxBufferLength: 10,
  maxMaxBufferLength: 10,
  backBufferLength: 10,
  testBandwidth: false,
  startLevel: 1,
  capLevelToPlayerSize: true,
  // Saved openings (A3-ALIGN §7): served from the segment store, everything else from the network.
  fLoader: SpeedyLoader as unknown as HlsConfig['fLoader'],
  pLoader: SpeedyLoader as unknown as HlsConfig['pLoader'],
} as const;
